import { LDClient } from 'launchdarkly-js-client-sdk';
import { getHomePath } from '@app/actions/navigation/routes';

export const HOME_PAGE_ENABLE_FLAG = 'webAppFtHomePageEnableFlag202605';

export const isHomePageLandingEnabled = (
  ldClient?: LDClient | null
): boolean => {
  if (!ldClient) return false;
  return Boolean(ldClient.allFlags()?.[HOME_PAGE_ENABLE_FLAG]);
};

export const getLoginLandingPath = (ldClient?: LDClient | null): string =>
  isHomePageLandingEnabled(ldClient) ? getHomePath() : '/dashboard';
